export default {
  common: {
    videoVisit: '{{MEMBERSHIP_NAME}} video visit',
    inPersonVisit: '{{MEMBERSHIP_NAME}} in-person visit',
    learnMore: 'Learn more',
  },
  account: {
    drawerCta: 'Get 24/7 access to affordable care with {{MEMBERSHIP_NAME}}',
    navTileTitle: 'Video Visit',
    navTileSubtitle: 'Get seen in minutes, 24/7',
  },
  entrypoints: {
    productModal: {
      time: {
        title: 'Video visits within {{TELEMED_SLA_MINUTES}} minutes',
      },
      fee: 'Membership fee',
      justCost: 'Just {{MEMBERSHIP_COST_STRING}} per month',
      cta: 'Get care now',
      learnMore: 'Learn more',
    },
    srp: {
      title: 'Save time and money with {{MEMBERSHIP_NAME}}',
      time: {
        title: '24/7 video visits within {{TELEMED_SLA_MINUTES}} minutes',
        subtitle: 'Care is only minutes away - even on holidays, nights, & weekends.',
      },
      cost: {
        title: 'One low price. No surprise bills.',
        subtitle:
          'No insurance? High deductible? Solv Plus video visits are only {{TELEMED_VISIT_COST_STRING}}.',
      },
      cta: 'Get care now',
      secondary: 'Learn more',
    },
    search: {
      member: {
        title: 'Need care now? Your {{MEMBERSHIP_NAME}} membership has you covered.',
        cta: 'Video chat with a provider now',
      },
      nonMember: {
        title: 'Video chat with a provider anytime, anywhere with {{MEMBERSHIP_NAME}}',
        subtitle:
          'Get 24/7 care for you & your kids at one low price per visit, including nights & weekends',
        cta: 'Learn more',
      },
      memberCta: 'Book now',
    },
  },
  landingPage: {
    splash: {
      title: '24/7 on-demand care, just $49 per visit',
      skipTheWait: 'Get seen in 15 minutes or less, day or night.',
      meetWithProviders: 'Speak with a top U.S. based provider by video.',
      simpleMembership: 'One simple membership for you and your kids.',
      disclaimer:
        'Membership is $14.99/month. Only $49 per visit. Introductory pricing subject to change.',
      cta: 'Sign up now',
    },
    howItWorks: {
      title: 'A membership built around you.',
      request: {
        title: '24/7 on-demand care',
        description: 'See an experienced provider today, in 15 minutes or less.',
      },
      connect: {
        title: 'Video visits',
        description: 'Join a video call from your phone or computer, at home or on the go.',
      },
      save: {
        title: 'Save on your care',
        description: 'Pay one flat price per visit. No surprise charges, no insurance necessary.',
      },
    },
    uses: {
      title: 'From everyday care to urgent needs, we’ll be here for you and your children.',
      medical: {
        title: 'Urgent care',
        badges: [
          'Cold & Flu',
          'Fever',
          'Headaches',
          'Pink eye',
          'STIs',
          'Sinus infections',
          'Sore throat',
          'UTIs',
          'Upset stomach',
          'Vomiting',
          'COVID-19',
        ],
      },
      family: {
        title: 'Everyday care',
        badges: ['Allergies', 'Birth control', 'Skin rashes & lesions', 'Travel health'],
      },
      prescription: {
        title: 'Prescription refills',
        subtitle: 'Fast, stress-free pickup for your medications.',
      },
    },
    membershipForYou: {
      title: 'Is a membership right for you?',
      subtitle:
        'Solv Plus is a great option for affordable, 24/7 guaranteed access to high-quality care.',
      subHeader: 'Solv Plus helps if you… ',
      kidsAtHome: {
        title: 'Have kids at home',
        description:
          'A Solv Plus membership makes urgent care visits more affordable, for all the common concerns (and just-in-case visits) of childhood.',
      },
      deductiblePlan: {
        title: 'Frequently use telehealth or urgent care',
        description:
          'Never worry if you’ll be able to find care or what the cost is going to be. Solv Plus offers no-wait video visits at one low fee, guaranteed.',
      },
      noInsurance: {
        title: 'On a HDHP or don’t have insurance',
        description:
          'If you’re on a HDHP and don’t hit your deductible, you’ll likely save money on care by paying out-of-pocket for Solv Plus instead.',
      },
    },
    pricing: {
      header: 'Simple pricing, no surprises.',
      title: "What's included:",
      costTitle: 'Monthly Membership',
      whatsIncluded: 'Fast 24/7 visits for you & your kids',
      sameDay: 'U.S.-based board certified doctors & nurse practitioners',
      providers: 'No long waits - get seen in <15 minutes',
      quick: 'No unexpected medical bills - one flat rate',
      noWait: 'Coming soon! No-wait in-person urgent care visits at a fixed price',
      monthlyCost: '{{MEMBERSHIP_COST_STRING}}/mo',
      visitCost: '{{TELEMED_VISIT_COST_STRING}}/visit*',
      disclaimer: 'One adult and up to 5 minor children included',
    },
    faq: {
      title: 'Frequently Asked Questions',
      questionsAndAnswers: {
        what: {
          question: 'What is Solv Plus?',
          answer:
            'Solv Plus is a membership plan offered by Solv that gives you 24/7 unlimited access to high-quality care via video visits with a U.S. based provider, including holidays, nights & weekends, for you and your kids. The membership includes a guarantee that you will receive care within 15 minutes.  You will also receive a premium level of support as part of your membership and will always receive a message back from our support team within the next business day.',
        },
        cost: {
          question: 'How much does the Solv Plus membership cost?',
          answer:
            'The membership fee is $14.99 per month and the video visit fee is $49 per visit. You will be charged the membership fee on a monthly basis.',
        },
        family: {
          question: 'How many family members are included in Solv Plus?',
          answer:
            'Your membership fee includes coverage for you and up to 5 minor children in your household. You will need to pay a visit fee each time you or your child has a video visit with a provider. Please note that as outlined in our <0>Terms of Service</0>, any profile set up on the same account may be viewed by other users under the same account, which may include records, personally identifiable information and information pertaining to their health and healthcare.',
        },
        conditions: {
          question: 'What is included in my membership? What conditions can be treated?',
          answer:
            'You can use your membership for many non-emergency urgent and everyday care concerns, including cough & cold symptoms, minor cuts & bruises, upset stomach, and UTIs. There are some conditions that we aren’t able to treat over video, such as severe shortness of breath, chest pain, persistent vomiting, deep lacerations and possible fractures. However, our providers can order labs as needed, recommend treatment, and prescribe medication if necessary. As always, you can use Solv to find same day in-person care options if there are partners in your area.',
        },
        hsa: {
          question:
            'Can I use my Health Savings Account (HSA) or Flexible Spending Account (FSA) to pay for Solv Plus?',
          answer:
            'The membership fee is not a covered benefit under health insurance plans or other healthcare benefit plans such as a Health Savings Account or Flexible Spending Account. At the time of purchase of a video visit, you will see a fee breakdown explaining the $49 charge; you may be able to submit a claim or use a FSA or HSA debit card to cover the medical services portion of the video visit fee.<br/>Note that a telemedicine portion of the video visit may be eligible for reimbursement with a flexible spending account (FSA), health savings account (HSA) and health reimbursement arrangement (HRA). Telemedicine is generally not eligible for reimbursement with a limited care flexible spending account (LCFSA) or a dependent care flexible spending account (DCFSA).',
        },
        insurance: {
          question: 'Do you need insurance to become a Solv Plus member?',
          answer:
            'Nope! Talking to a doctor or an advanced practice provider (nurse practitioner, physician assistant) is the same affordable price with or without insurance.',
        },
        insuranceForVisits: {
          question: 'Can I use my insurance to pay for my visits?',
          answer:
            'Solv Plus does not accept insurance as there is a simple cash-pay rate for visits.',
        },
        sla: {
          question: 'What if I don’t receive care within 15 minutes?',
          answer:
            'If you request care and are not seen within 15 minutes or less, and you let us know in writing at <0>plussupport@solvhealth.com</0> within 15 calendar days after the video visit, we will refund you for the full cost of the Solv membership fee for the month in which the visit occurred.',
        },
        labs: {
          question: 'What if I need a lab test?',
          answer:
            'If your provider recommends that you get a lab test done, they will order a lab test at a local lab or urgent care near you. You will need to pay separately for the cost of the lab test.',
        },
        rx: {
          question: 'Does my membership include access to prescriptions and prescription refills?',
          answer:
            'Yes, if your provider deems it necessary, they will write a prescription and send it to a local pharmacy convenient for you. The cost of the prescription drug is not covered by your membership or visit fee, and you will need to pay that separately. Of course, you may be eligible for prescription coverage under your applicable insurance plan -- please check with your plan for specifics.',
        },
        states: {
          question: 'Is Solv Plus available in all 50 states? What if I go on vacation?',
          answer:
            'Currently, Solv Plus is only available to residents of California, Texas, and Washington. When traveling, you will be able to use your membership if you are located within the states that are listed here. We will be adding many more states soon so check back often to see when your area has coverage. Solv Plus is not available outside of the United States.',
        },
        cancel: {
          question: 'What if I want to cancel my membership?',
          answer:
            'The membership fee is a recurring fee and will be billed monthly; however, you can cancel your membership at any time via your Account or by emailing plussupport@solvhealth.com. As long as you cancel your membership before the next billing period, you will not be billed the monthly fee for the next period. See our <0>Terms of Service</0> for more details.',
        },
        provider: {
          question: 'What if I’m a provider who wants to be involved with Solv Plus?',
          answer:
            'For more information about the benefits of participating in the Solv Plus network, please <0>apply here to get on the waitlist</0> and we will be in touch. There is no cost to participate.',
        },
        questions: {
          question: 'What if I have another question not answered here?',
          answer:
            'We’d be happy to help. Just send us an email at plussupport@solvhealth.com and we’ll get back to you soon.',
        },
      },
    },
    contactUs: {
      title: 'Have a different question?',
      subtitle:
        'We’d be happy to help. Just send us an email at {{MEMBERSHIP_SUPPORT_EMAIL}} and we’ll get back to you soon.',
    },
    providerSection: {
      title: 'Information for Healthcare Providers',
      description:
        'Today, our 24/7 telehealth providers are trained on how to refer patients that need a higher level of care to in-person Solv partners. In the future, Solv Plus members will be able to schedule no-wait, flat fee in-person visits, providing opportunities for partners to participate further. Partners will also have the opportunity to provide telehealth services as part of Solv Plus.',
      interested:
        'If you’re a provider and are interested in participating with Solv Plus, we’d love to hear from you!',
      waitlistUrlText: 'Apply here to get on our waitlist',
      willBeInTouch: 'and we’ll be in touch when there is availability in your market.',
    },
    cta: 'Sign me up',
  },
  payment: {
    title: 'Enter payment details',
    maybeNotAvailable: '{{MEMBERSHIP_NAME}} might not be avaiable in your state yet.',
    genericError: 'Something went wrong creating your subscription',
    seeSupportedStates: 'See which states we support',
    lineItemTitle: '{{MEMBERSHIP_NAME}} Monthly Membership',
    lineItemSubtitle:
      '24/7 access to {{TELEMED_VISIT_COST_STRING}} video visits for your family. Cancel anytime.',
    costPerMonth: '{{MEMBERSHIP_COST_STRING}}/month',
    dueNow: 'Total Due Now',
    cardDetails: 'Card details',
    errors: {
      alreadyHasMembership: {
        title: 'You already have a membership',
        bookAVisit: 'Book a visit now',
        goHome: 'Go to my account',
      },
    },
    solvEmployee: {
      title: 'You are a Solv employee',
      subtitle:
        'Please use your real credit card on this form. You will not be charged any monthly fee, but you will be responsible for all $49 video visit fees.',
    },
    legal: {
      preButton:
        'You will be charged {{MEMBERSHIP_COST_STRING}} automatically every month until you cancel. Your price may change as described in Solv’s <1>Terms of Service</1>. This card will be charged automatically for the visit fee after each completed visit. You can <2>cancel your membership</2> at any time in the Solv app or by <3>contacting support.</3>',
      postButton:
        'By clicking Subscribe, you agree to Solv’s <1>Terms of Service</1> and <2>Privacy Policy.</2>',
    },
    disclaimer: {
      title: 'Important: by clicking “Subscribe” you agree that:',
      availability: '{{MEMBERSHIP_NAME}} is not yet available in all states.',
      recurringCharge:
        'You are signing up for a {{MEMBERSHIP_NAME}} monthly membership and your card will be charged {{MEMBERSHIP_COST_STRING}} every month until you cancel your membership.',
      cancel:
        'You can cancel your membership at any time in the Solv app or by contacting support.',
      autoCharge:
        'This card will be charged automatically for the visit fee after each completed visit.',
    },
    supportedStates: {
      title: '{{MEMBERSHIP_NAME}} supported states',
      subtitle:
        'We are adding new states to {{MEMBERSHIP_NAME}} all the time. Right now, the supported states are:',
    },
    warning: {
      title: 'Solv plus is not yet available in {{state}}.',
      subtitle: 'We do not have providers licensed in that state to provide care.',
      cta: 'Subscribe anyway',
    },
  },
  titles: {
    location: 'Visit location',
    newLocation: 'Visit location',
    time: 'Visit time',
    profile: 'Visit profile',
    newProfile: 'New Profile',
    reason: 'Reason for Visit',
    finalize: 'Finalize Visit',
    default: 'Book',
  },
  timeSlots: {
    sla: 'Within next {{sla}} minutes',
    timePrompt: 'When do you want your visit?',
    timePromptVideo: 'When do you want your video visit?',
    seeAllTimes: 'See all times',
    seeFewerTimes: 'See fewer times',
    loading: 'Loading available time slots',
  },
  stateConfirmation: {
    title: 'Where will the patient be at the time of the video visit?',
    subtitle: 'This helps us connect to the best provider for your needs',
    locating: 'Finding your location',
    otherState: 'Somewhere else',
    noDetectedState: 'Choose a state',
    stateError: {
      title: `We're not sure where you are`,
      subtitle: 'Please select the state you are currently in so we can match you with a provider.',
    },
  },
  stateSelection: {
    title: 'Select a state',
    subtitle:
      'This helps us connect you to a doctor licensed in the same state the patient will be in.',
    notFindingStateTitle: 'Not finding your state?',
    notFindingStateCopy:
      'If your state is not listed above, {{MEMBERSHIP_NAME}} is not yet available. You can return to search for care at clinics on Solv.',
    notFindingStateCta: 'Find care on Solv',
    selectAnotherState: 'Select another state',
    loading: 'Loading supported states',
  },
  selectProfile: {
    title: 'Who is this visit for?',
    subtitle: 'Please select or add a family member below',
    months: '{{count}} month',
    months_plural: '{{count}} months',
    years: '{{count}} year',
    years_plural: '{{count}} years',
    childAge:
      '$t(selectProfile.years, { "count": {{years}} }) $t(selectProfile.months, { "count": {{months}} })',
    addProfile: 'Add a family member',
    loading: 'Loading your profiles',
  },
  successDialog: {
    title: 'Welcome to {{MEMBERSHIP_NAME}}',
    subtitle:
      'Your membership includes 24/7 care for you and your kids. Get seen today in less than {{TELEMED_SLA_MINUTES}} minutes for common concerns. Think COVID, cold & flu symptoms, UTIs, earaches and more.',
    book: 'Book a video visit now',
  },
  newProfile: {
    title: 'Who is this visit for?',
    subtitle: "Please add the patient's information below",
    error:
      'Something went wrong. Please check that all of your fields are correct and try again, or try again later.',
    nameRequired: 'First and last name are required',
    birthDateRequired: 'Birth date is required',
    first: 'First name',
    last: 'Last name',
    patientName: 'Patient Name',
    birthDate: 'Patient date of birth',
    relationship: "Patient's relationship to you",
    relationships: {
      self: 'Self',
      parent: 'Parent',
      sibling: 'Sibling',
      child: 'Child',
      spouse: 'Spouse',
      other: 'Other',
    },
    sex: 'Patient birth sex',
    sexes: {
      female: 'Female',
      male: 'Male',
      other: 'Other',
    },
  },
  reasonForVisit: {
    title: 'How can we help {{name}}',
    subtitle: 'Briefly describe the reason for visit',
    useFor: 'Use {{MEMBERSHIP_NAME}} video visits for',
    issuesNotTreated: 'Not supported in video visits',
    reason: {
      cold: 'Minor colds, coughs, & flus',
      cuts: 'Minor cuts, scrapes, & burns',
      rashes: 'Some rashes',
      allergies: 'Seasonal allergies',
      prescriptions: 'Prescriptions',
      uti: 'UTI',
      questions: 'General questions or concerns',
      headInjuries: 'Major head injuries',
      sports: 'Sports physicals',
      wellness: 'Wellness exams',
      vaccine: 'Vaccines',
      controlledSubstances: 'Prescriptions for controlled substances',
    },
  },
  finalizeVisit: {
    title: 'Review and confirm',
    subtitle: 'You’re almost done! Please review the information below and confirm your booking.',
    visitDetails: 'Visit details',
    paymentDue: 'Payment due after visit',
    patient: 'Patient',
    service: 'Service',
    when: 'When',
    where: 'Where',
    amount: 'Amount',
    paymentMethod: 'Payment method',
    chargedAfter: 'charged after visit',
    confirmBooking: 'Confirm booking',
    cardAlert: {
      invalid: 'Your saved payment method is no longer valid.',
      noCard: 'You have no saved payment method',
      action: 'Please add a new payment method',
    },
    errors: {
      slotTaken: {
        body: 'Sorry, the time you selected is no longer available',
        action: 'Please select a new time',
      },
    },
    updateCard: 'Update payment method',
    addCard: 'Add payment method',
    legal:
      'By clicking “Confirm booking”, you agree to Solv’s <1>Terms of Service</1> and <2>Privacy Policy</2>.',
  },
  feesModal: {
    title: 'Solv Member Telehealth Services',
    copy: '<p>The {{TELEMED_VISIT_COST_STRING}} video visit price includes the medical services cost for an independent health care provider, not affiliated with Solv Health, to conduct your telehealth visit, plus fees for other administrative, technology and operational support.</p><p>Of the fee, up to {{MEMBERSHIP_CARD_FEE}} is charged as a processing fee paid to the credit card processor, {{STEADYMD_FEE}} is paid to the independent health care provider for medical services, and the remainder is paid to Solv Health for technology and administrative services. These charges are non-refundable.</p>',
  },
};
